var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4482 15.3184C21.0466 16.4034 22.1666 17.8734 22.1666 19.8334V23.3334H25.6666C26.3082 23.3334 26.8332 22.8084 26.8332 22.1667V19.8334C26.8332 17.29 22.6682 15.785 19.4482 15.3184Z",
    fill: "#B784EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4987 14.0001C13.076 14.0001 15.1654 11.9107 15.1654 9.33341C15.1654 6.75609 13.076 4.66675 10.4987 4.66675C7.92137 4.66675 5.83203 6.75609 5.83203 9.33341C5.83203 11.9107 7.92137 14.0001 10.4987 14.0001Z",
    fill: "#B784EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4989 14.0001C20.0773 14.0001 22.1656 11.9117 22.1656 9.33341C22.1656 6.75508 20.0773 4.66675 17.4989 4.66675C16.9506 4.66675 16.4373 4.78341 15.9473 4.94675C16.9156 6.14841 17.4989 7.67675 17.4989 9.33341C17.4989 10.9901 16.9156 12.5184 15.9473 13.7201C16.4373 13.8834 16.9506 14.0001 17.4989 14.0001Z",
    fill: "#B784EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4984 15.1667C7.38337 15.1667 1.16504 16.7301 1.16504 19.8334V22.1667C1.16504 22.8084 1.69004 23.3334 2.33171 23.3334H18.665C19.3067 23.3334 19.8317 22.8084 19.8317 22.1667V19.8334C19.8317 16.7301 13.6134 15.1667 10.4984 15.1667Z",
    fill: "#B784EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.df766b9b62c2ca1def532ae70ae53dbc.svg";
export { ForwardRef as ReactComponent };